import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, Phone, BadgePercent } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";

const LINKS = [
  { to: "/rentals", label: "Vacation Rentals" },
  { to: "/weddings", label: "Weddings & Events" },
  { to: "/property-management", label: "Property Management" },
  { to: "/owner-services", label: "Owner Services" },
  { to: "/reviews", label: "Reviews" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 glass border-b border-black/5">
      <div data-testid="savings-banner"
        className="flex items-center justify-center gap-2 bg-ink px-4 py-1.5 text-center text-[11px] font-medium tracking-wide text-cream sm:text-xs">
        <BadgePercent size={14} strokeWidth={1.75} className="shrink-0 text-camel" />
        <span>Save ~15% vs Airbnb — <span className="font-semibold">book direct</span> with no service fees</span>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="text-2xl font-semibold tracking-tight text-ink">Elite STR</span>
          <span className="overline mt-0.5 text-[9px]">Hosting Co.</span>
        </Link>

        <nav className="hidden items-center gap-6 xl:flex">
          {LINKS.slice(0, 6).map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm font-medium text-ink/80 transition-colors hover:text-camel">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button data-testid="nav-guest-login" variant="ghost" onClick={() => nav("/guest")}
            className="hidden rounded-full text-sm font-medium text-ink hover:bg-cream lg:inline-flex">
            Guest Login
          </Button>
          <Button data-testid="nav-owner-portal" variant="ghost"
            onClick={() => nav("/admin")}
            className="hidden rounded-full text-sm font-medium text-ink hover:bg-cream lg:inline-flex">
            Owner Portal
          </Button>
          <Button data-testid="nav-book-btn" onClick={() => nav("/rentals")}
            className="hidden rounded-full btn-ink px-5 sm:inline-flex">
            Book Your Stay
          </Button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button data-testid="nav-menu-btn" variant="outline" size="icon"
                className="rounded-full border-black/10 xl:hidden">
                <Menu size={20} strokeWidth={1.5} />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80">
              <div className="mt-8 flex flex-col gap-1">
                {[{ to: "/", label: "Home" }, ...LINKS].map((l) => (
                  <SheetClose asChild key={l.to}>
                    <Link to={l.to} data-testid={`mobile-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
                      className="rounded-xl px-4 py-3 text-lg text-ink transition-colors hover:bg-cream">
                      {l.label}
                    </Link>
                  </SheetClose>
                ))}
                <SheetClose asChild>
                  <Link to="/guest" data-testid="mobile-nav-guest-login"
                    className="rounded-xl px-4 py-3 text-lg text-ink transition-colors hover:bg-cream">
                    Guest Login
                  </Link>
                </SheetClose>
                <SheetClose asChild>
                  <Link to="/admin" data-testid="mobile-nav-admin"
                    className="rounded-xl px-4 py-3 text-lg text-ink transition-colors hover:bg-cream">
                    Admin Dashboard
                  </Link>
                </SheetClose>
                <a href="tel:+12102743556" className="mt-4 flex items-center gap-2 rounded-xl bg-cream px-4 py-3 text-ink">
                  <Phone size={18} strokeWidth={1.5} /> (210) 274-3556
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
